import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Gift, Copy } from "lucide-react";

export function ReferralPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/me/referral").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const shareUrl = `${window.location.origin}/register?ref=${data.referral_code}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Share link copied");
    } catch { toast.error("Copy failed"); }
  };

  return (
    <div data-testid="referral-panel" className="border hairline p-6">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 border hairline flex items-center justify-center">
          <Gift size={20} className="text-[#FF3B30]" />
        </div>
        <div className="flex-1">
          <div className="tick-label">Referral credits</div>
          <div className="font-display text-2xl font-bold mt-1">Invite friends. Earn $10 each.</div>
          <p className="text-neutral-400 text-sm mt-1">
            Share your link — you get <strong>$10 credit</strong> the moment a friend pays for their first kitchen.
            Credit auto-applies at your next checkout.
          </p>

          <div className="mt-4 flex items-stretch gap-2">
            <input
              data-testid="referral-link"
              readOnly
              value={shareUrl}
              onFocus={(e) => e.target.select()}
              className="flex-1 border hairline px-3 py-2 font-mono text-xs focus:outline-none"
            />
            <button data-testid="referral-copy" onClick={copy} className="btn-outline inline-flex items-center gap-2">
              <Copy size={12} /> Copy
            </button>
          </div>

          <div className="mt-4 grid grid-cols-3 gap-0 border hairline">
            <StatCell label="Your code" value={data.referral_code} mono />
            <StatCell label="Friends referred" value={data.referred_count} />
            <StatCell label="Credit balance" value={`$${data.credit_balance.toFixed(2)}`} highlight />
          </div>
        </div>
      </div>
    </div>
  );
}

function StatCell({ label, value, mono, highlight }) {
  return (
    <div className="p-4 border-r hairline last:border-r-0">
      <div className="tick-label">{label}</div>
      <div className={`${mono ? "font-mono" : "font-display"} text-xl font-bold mt-1 ${highlight ? "text-[#FF3B30]" : ""}`}>{value}</div>
    </div>
  );
}
